import { HttpHelper } from "@/helper/HttpHelper";
import { setValueInCookies } from "./constantService";

// Login API
export const loginAPI = async (request) => {
        const {email, password} = await request;
        const body = {
            email: email,
            password: password
        }
        const apiUrl = process.env.NEXT_PUBLIC_BASE_URL + '/login';
        const response = await HttpHelper.post(apiUrl, body).then((response) => response.data);
        
        // Store token in cookies
        setValueInCookies({token: response.data.access_token});
        // Get User Details from API
        const userDetails = await getUserDetailsAPI({token: response.data.access_token});

        const tempTable = {};
        tempTable['user'] = userDetails.data;
        tempTable['message'] = response.message;
        tempTable['token'] = response.data.access_token;
        const base64EncodedData = btoa(unescape(encodeURIComponent(JSON.stringify(tempTable))));
        localStorage.setItem('sessiondata', base64EncodedData); 
        return tempTable;
}

// Get User Details API
export const getUserDetailsAPI = async (request) => {
    const {token} = await request;
    const apiUrl = process.env.NEXT_PUBLIC_BASE_URL + '/auth/user-info';
    const headers = {
        'Authorization': `Bearer ${token}`
    }
    const body = {
        token: token
    }
    const response = await HttpHelper.get(apiUrl, body, {headers: headers}).then((response) => response.data);
    return response;
}

// Register API
export const registerAPI = async (request) => {
        const {name, email, password} = await request;
        const body = {
            name: name,
            email: email,
            password: password
        }
        const apiUrl = process.env.NEXT_PUBLIC_BASE_URL + '/register';
        const response = await HttpHelper.post(apiUrl, request).then((response) => response.data);
        return response;
}

// Verify Email API
export const verifyEmailAPI = async (request) => {
    const {token} = await request;
    const apiUrl = process.env.NEXT_PUBLIC_BASE_URL + '/verify-email';
    const body = {
        token: token
    }
    const response = await HttpHelper.post(apiUrl, body).then((response) => response.data);
    return response;
    
}

// Forgot Password API - request an OTP
export const forgotPasswordAPI = async (request) => {
    const {email} = await request;
    const body = {
        email: email
    }
    const apiUrl = process.env.NEXT_PUBLIC_BASE_URL + '/forgot-password';
    const response = await HttpHelper.post(apiUrl, body).then((response) => response.data);
    return response;
}

// Reset Password API - submit OTP and new password
export const resetPasswordAPI = async (request) => {
    const {email, otp, new_password, new_password_confirmation} = await request;
    const body = {
        email: email,
        otp: otp,
        new_password: new_password,
        new_password_confirmation: new_password_confirmation
    }
    const apiUrl = process.env.NEXT_PUBLIC_BASE_URL + '/reset-password';
    const response = await HttpHelper.post(apiUrl, body).then((response) => response.data);
    return response;
}

// Verify Newsletter Subscription API
export const verifyNewsletterSubscriptionAPI = async (token) => {
    const body = {
        token: token
    }
        const apiUrl = process.env.NEXT_PUBLIC_BASE_URL + '/newsletter/verify';
        const response = await HttpHelper.post(apiUrl, body).then((response) => response.data);
        return response;
    
}

// Get Author User Details API
export const getAuthorUserDetailsAPI = async ( request) => {
    const {id} = await request;
    try {
        const apiUrl = process.env.NEXT_PUBLIC_BASE_URL + '/author/' + id;
        const response = await HttpHelper.get(apiUrl).then((response) => response.data);
        return response;
    } catch (error) {
        console.error('Error getting author user details:', error);
        return [];
    }
}

// Get Author Articles with Pagination
export const getAuthorArticlesAPI = async ({ id, page = 1, per_page = 5 }) => {
    try {
        const apiUrl = `${process.env.NEXT_PUBLIC_BASE_URL}/author/${id}?page=${page}&per_page=${per_page}`;
        const response = await HttpHelper.get(apiUrl).then((response) => response.data);
        return response;
    } catch (error) {
        console.error('Error getting author articles:', error);
        return null;
    }
}

// Google Login API
export const googleLoginAPI = async () => {
    const apiUrl = process.env.NEXT_PUBLIC_BASE_URL + '/auth/google/redirect';
    
    const response = await HttpHelper.get(apiUrl).then((response) => response.data);
    return response;
}

// Google Callback API
export const googleCallbackAPI = async (request) => {
    const { code } = await request;
    const apiUrl = process.env.NEXT_PUBLIC_BASE_URL + '/auth/google/callback?code=' + code;
    const response = await HttpHelper.get(apiUrl).then((response) => response.data);
    return response;
}

// LinkedIn Login API
export const linkedinLoginAPI = async () => {
    const apiUrl = process.env.NEXT_PUBLIC_BASE_URL + '/auth/linkedin/redirect';

    const response = await HttpHelper.get(apiUrl).then((response) => response.data);
    return response;
}

// LinkedIn Callback API
export const linkedinCallbackAPI = async (request) => {
    const { code } = await request;
    const apiUrl = process.env.NEXT_PUBLIC_BASE_URL + '/auth/linkedin/callback?code=' + code;
    const response = await HttpHelper.get(apiUrl).then((response) => response.data);
    return response;
}